import React from "react";
import PropTypes from "prop-types";
import {PromoBanner} from "./PromoBanner";

export class UserBookizonSubscriptionView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        if (this.props.user.is_bookizon_plus_active) return '';
        if (!this.props.user.is_bookizon_plus_demo) return '';
        return (
            <React.Fragment>
                {
                    <div className={"container my-3"}>
                        <PromoBanner user={this.props.user}/>
                    </div>
                }
            </React.Fragment>
        )
    }

}

UserBookizonSubscriptionView.propTypes = {
    user: PropTypes.shape({
        id_utente: PropTypes.any,
        nome: PropTypes.string,
        cognome: PropTypes.string,
        is_bookizon_plus_demo: PropTypes.bool,
        is_bookizon_plus_active: PropTypes.bool,
        has_default_google_calendar: PropTypes.bool,
    })
}
